/* 车型专题页（01–10）埋点（2026-10-13 建，10-14 与 Codex Astra max 联合评审两轮后重做；随 PR #55 一起上线）。方案与报表：docs/vehicle-pages-tracking-plan.zh-CN.md
   目的：看新版车型页有没有用、哪些模块 / 按钮 / 车型最常用、能不能带来加购和订单。

   发送：用主题已有的 gtag 直接发给 GA4（snippets/marketing-tags-head.liquid 的 __ga4ThemeConfig.measurementId），同一份数据推进 dataLayer（event: 'apsp_event'）。
   只有正式主题（Shopify.theme.role = main、不在主题编辑器里）才发；预览 / 开发主题默认只记在 window.__apspLog，不进正式数据。
   测试：网址加 ?apsp_test=1 把本浏览器标为测试者（?apsp_test=0 取消）：事件带 debug_mode + traffic_type=internal，GA4 数据过滤器「Developer Traffic apsp test」按 debug_mode 排除；
   marketing-tags-head 对测试者的主题 GA4 配置也加 debug_mode；购物车归因值前面加「TEST 」。预览主题上加 ?apsp_debug=1 也按测试者发送。
   个人信息：上线车型来自车型清单；网址带进来的非上线车型要在全站车型目录里查到才上报（查不到不报、不写购物车）；文字参数去邮箱和电话号码；
   page_location 去掉疑似个人信息的查询参数，utm_* 的值也去邮箱，广告点击 ID（gclid 等）原样保留。

   事件（参数要在 GA4 登记为事件范围的自定义维度，清单见方案文档）：
     apsp_page_view      进入页面一次：apsp_page（01–10）、车型（vehicle_key / vehicle_year / vehicle_make / vehicle_model / vehicle_supported）、position
     apsp_module_view    模块第一次有 40% 进入视口（或可见高度达到视口 40%；每页每个模块一次；点击前没记到的先补一次）：apsp_module（固定 ID：data-apsp-module）、apsp_module_title
     apsp_click          页面里的链接 / 按钮 / 卡片被点（意图；打开视频也记一次 apsp_target = video）：apsp_module、apsp_module_title、apsp_label、apsp_item、apsp_target、content_years（06 所在年份段）
     apsp_vehicle_select 选车成功（业务代码确认后调用 AuxitoTrack.vehicleSelected）：apsp_source、selected_year / selected_make / selected_model；本事件的 vehicle_* 也是所选车型
                         全站选车器都报（2026-10-14 补）：车型页内 hero / task_card / garage_modal / vehicle_card / bsg_card；
                         页头 My Garage header_garage、产品分类菜单 Find by Vehicle category_menu、商品页 / 博客适配检查 pdp_fitment、
                         首页 Shop by Vehicle home_finder、/pages/search 查灯泡尺寸 bsg_search、品牌页 Finder brand_finder、活动页套装 kit_offer。
                         非车型页上 apsp_page 为空，页面看 GA4 自带的网页路径；vehicle_supported 按全站上线车型清单判断
     apsp_select         页面里其他下拉（如 09 灯位配置）：apsp_module、apsp_field、apsp_value、apsp_item
     apsp_video_open     打开视频：apsp_module、apsp_label（视频标题）、video_id
     apsp_video_play     视频真正开始播放（YouTube 播放器报告 playing；06 页的视频不能判断，只有 open）
     apsp_result         结果状态：apsp_result（no_match / load_failed / unsupported_vehicle / no_products / config_required / products / add_to_cart_failed）、result_count
     apsp_add_to_cart    09 / 10 Builder「Add All to Cart」成功：value、currency、item_count（不用 items，那是 GA4 电商保留的商品数组）
   页面编号：sections/auxito-proto-shell.liquid 的 data-apsp-screen；06 新版灯泡尺寸页（.apsp.bsg2）记 06；05 由引入脚本的 data-apsp-track-page 指定。 */
(function () {
  'use strict';
  if (window.AuxitoTrack) return;

  /* 本脚本全站加载（layout/theme.liquid，带上线车型清单 data-apsp-launched），05 / 06 页面另有一份带 data-apsp-track-page 的引用；
     都是 defer，执行时页面已解析完，按属性查找，不依赖哪一份先执行 */
  var pageTag = document.querySelector('script[data-apsp-track-page]');
  var forcedPage = pageTag && pageTag.getAttribute('data-apsp-track-page');
  var sentModules = {};
  var pageCtx = null;
  var log = window.__apspLog = window.__apspLog || [];

  /* ---------- 环境：正式 / 测试者 / 预览 ---------- */
  var query = new URLSearchParams(window.location.search);
  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { if (v == null) window.localStorage.removeItem(k); else window.localStorage.setItem(k, v); } catch (e) { /* 忽略 */ } }
  /* 测试身份在 snippets/marketing-tags-head.liquid 里先解析（主题 GA4 配置要用），这里再解析一次，两边结果一致 */
  if (query.get('apsp_test') === '1') lsSet('apsp:tester', '1');
  if (query.get('apsp_test') === '0') lsSet('apsp:tester', null);
  try { if (query.get('apsp_debug') === '1') window.sessionStorage.setItem('apsp:debug', '1'); } catch (e) { /* 忽略 */ }
  var LIVE = (function () {
    try { return !!(window.Shopify && window.Shopify.theme && window.Shopify.theme.role === 'main' && !window.Shopify.designMode); } catch (e) { return false; }
  })();
  var TESTER = lsGet('apsp:tester') === '1';
  var DEBUG = (function () { try { return window.sessionStorage.getItem('apsp:debug') === '1'; } catch (e) { return false; } })();
  /* live：正常发送；internal：发送但标为测试流量；off：只记 window.__apspLog */
  var MODE = TESTER || DEBUG ? 'internal' : (LIVE ? 'live' : 'off'); /* 测试身份与 marketing-tags-head 的主题 GA4 配置同一规则 */
  var TEST_PREFIX = MODE === 'live' ? '' : 'TEST ';
  var VERSION = '2026-10-14'; /* 埋点版本（apsp_page_view 的 apsp_version），口径改动时更新 */

  /* ---------- 文字清理与个人信息过滤 ---------- */
  function clean(text, max) {
    return String(text == null ? '' : text).replace(/\s+/g, ' ').trim().slice(0, max || 100);
  }
  var EMAIL = /[^\s@<>()"'&=?]+@[^\s@<>()"'&=?]+\.[^\s@<>()"'&=?]+/g;
  /* 电话：常见 10 位格式（可带 +1、括号、空格、点、连字符）或 9 位以上连续数字；年份段（2007–2014）、车型数字（1500）不受影响 */
  var PHONE = /(?:\+?\d{1,2}[\s.-]?)?\(?\b\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}\b|\b\d{9,}\b/g;
  function scrub(text) {
    return String(text).replace(EMAIL, '[redacted]').replace(PHONE, '[redacted]');
  }
  function safeYear(y) {
    y = String(y == null ? '' : y).trim();
    return /^(19|20)\d\d$/.test(y) ? y : '';
  }
  function niceModel(m) { return clean(m, 60).replace(/\bhd\b/gi, 'HD'); }
  function slug(parts) {
    return clean(parts.filter(Boolean).join('-').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''), 80);
  }
  /* 车型维度统一写法：vehicle_key = 年份-品牌-车型（小写连字符）；只有车型没有年份的页面（02）为 品牌-车型。
     只用于已确认的车型（车型清单 / 车型目录 / 选车下拉里的值） */
  function vehicleFields(v, modelLevel) {
    var out = { vehicle_key: '', vehicle_year: '', vehicle_make: '', vehicle_model: '' };
    if (!v) return out;
    var y = modelLevel ? '' : safeYear(v.year);
    var mk = clean(v.make, 40);
    var md = niceModel(v.model);
    if (!mk || !md || (!modelLevel && !y)) return out;
    out.vehicle_key = slug([y, mk, md]);
    out.vehicle_year = y;
    out.vehicle_make = mk;
    out.vehicle_model = md;
    return out;
  }
  /* page_location：广告点击 ID 原样保留（GA4 判断会话来源要用）；utm_* 保留但值去邮箱 / 电话；疑似个人信息的参数整个去掉；其余值去邮箱 / 电话 */
  var CLICK_IDS = /^(gclid|gbraid|wbraid|dclid|msclkid|fbclid|ttclid|srsltid|_gl|gad_source|gad_campaignid)$/i;
  var DROP_KEYS = /mail|phone|tel|name|addr|zip|postal|token|password|key$/i;
  function safeUrl(href, keepQuery) {
    /* 车型专题页事件的车型都在 vehicle_* 里（已确认的值），page_location 一律不带网址里的原始 year / make / model（可能是没确认的任意文字） */
    var dropVehicle = true;
    if (typeof window.__apspSafeUrl === 'function') return window.__apspSafeUrl(href, keepQuery, dropVehicle); /* 与主题 page_view 共用（marketing-tags-head） */
    var u;
    try { u = new URL(href); } catch (e) { return ''; }
    if (!keepQuery) return u.origin + u.pathname;
    var out = new URLSearchParams();
    u.searchParams.forEach(function (val, key) {
      if (CLICK_IDS.test(key)) { out.append(key, val); return; }
      if (key.indexOf('apsp_') === 0 || (!/^utm_/i.test(key) && DROP_KEYS.test(key))) return;
      if (dropVehicle && /^(year|make|model)$/i.test(key)) return; /* 网址里的原始车型参数不报 */
      out.append(key, scrub(val));
    });
    var qs = out.toString();
    return u.origin + u.pathname + (qs ? '?' + qs : '');
  }
  /* 网址带进来、还没在车型目录里确认的车型文字（面包屑、卡片标题里都有）：确认前在所有参数里替换掉 */
  function maskUnverified(text) {
    if (outsideState === 'ok' || outsideState === 'none') return text;
    var c = window.AuxitoProtoShellVehicle;
    var o = c && c.outside;
    if (!o) return text;
    var out = String(text).replace(/\s+/g, ' ');
    var words = [];
    [o.make, o.model].forEach(function (x) { String(x || '').split(/\s+/).forEach(function (t) { if (t.length >= 3 && !/^\d+$/.test(t)) words.push(t); }); });
    [o.name, [o.make, o.model].join(' '), o.model, o.make].concat(words).forEach(function (w) {
      w = String(w || '').replace(/\s+/g, ' ').trim(); /* 和事件文字同样把连续空白合成一个，避免对不上 */
      if (w.length < 2) return;
      out = out.split(w).join('[vehicle]');
      var lw = w.toLowerCase();
      var idx = out.toLowerCase().indexOf(lw);
      while (idx >= 0) { out = out.slice(0, idx) + '[vehicle]' + out.slice(idx + w.length); idx = out.toLowerCase().indexOf(lw, idx + 9); }
    });
    return out;
  }
  /* 这些参数是程序生成的结构化值，不做文字清理（避免年份段等被误当成电话） */
  var STRUCTURED = { vehicle_key: 1, vehicle_year: 1, content_years: 1, video_id: 1, apsp_module: 1, apsp_page: 1, page_location: 1, page_referrer: 1, page_path: 1 };

  /* ---------- 发送 ---------- */
  var CARRY_KEY = 'apsp:carry';
  /* GA4 是否已加载完：gtag('get', 编号, 'client_id', 回调) 有回调就说明这个 GA4 编号已经加载完（公开接口）。
     这个编号由 Google 代码容器（GT-…）稍后注册，注册前发出的 get 会被丢掉、不回调，所以每 0.5 秒问一次，有回调就停（最多 30 秒）。
     不能查 google_tag_manager[编号]：正式站没有以 G- 编号为键的条目，原来按它判断永远是「没加载完」，
     跳转前的选车事件全部积在本标签页、一条也没送出（2026-10-16 发现）。 */
  var gaReady = false;
  var gaWaiters = [];
  var gaWatching = false;
  /* 有事件要等时才开始问（不在每个页面都轮询） */
  function whenGaReady(fn) {
    if (gaReady) { fn(); return; }
    gaWaiters.push(fn);
    if (!gaWatching) { gaWatching = true; watchGa(0); }
  }
  function watchGa(tries) {
    var cfg = window.__ga4ThemeConfig;
    if (gaReady || !cfg || !cfg.measurementId || typeof window.gtag !== 'function') return;
    try {
      window.gtag('get', cfg.measurementId, 'client_id', function () {
        if (gaReady) return;
        gaReady = true;
        var list = gaWaiters;
        gaWaiters = [];
        list.forEach(function (fn) { try { fn(); } catch (e) { /* 忽略 */ } });
      });
    } catch (e) { /* 忽略 */ }
    if (tries < 60) window.setTimeout(function () { watchGa(tries + 1); }, 500);
    else if (!gaReady) gaWatching = false; /* 30 秒还没加载完：下一个要等的事件重新开始问 */
  }
  function deliver(name, payload) {
    try {
      var dl = window.dataLayer = window.dataLayer || [];
      var data = { event: 'apsp_event', apsp_event: name };
      Object.keys(payload).forEach(function (k) { data[k] = payload[k]; });
      dl.push(data);
    } catch (e) { /* 埋点失败不影响页面 */ }
    try {
      var cfg = window.__ga4ThemeConfig;
      /* 按 GA4 编号发（2026-10-13 实测：发给 ga4_theme 分组的事件不会送出，直接写编号才送达） */
      if (typeof window.gtag === 'function' && cfg && cfg.measurementId) {
        var g = {};
        Object.keys(payload).forEach(function (k) { g[k] = payload[k]; });
        g.send_to = cfg.measurementId;
        window.gtag('event', name, g);
      }
    } catch (e) { /* 同上 */ }
  }
  /* opts.beforeLeave：调用方随后会立即跳转。一律先存到本标签页：本页随即跳走时，Google 代码还没加载完或已收下但没来得及送出的事件都会丢
     （2026-10-16 正式站实测：GA4 收下事件后约 5 秒才统一送出，期间跳转就丢），由下一页补发；10 秒后仍在本页（没有跳转）就自己取出发送 */
  function send(name, params, opts) {
    var payload = {};
    var base = context();
    Object.keys(base).forEach(function (k) { if (base[k] !== '' && base[k] != null) payload[k] = base[k]; });
    Object.keys(params || {}).forEach(function (k) { if (params[k] !== '' && params[k] != null) payload[k] = params[k]; });
    Object.keys(payload).forEach(function (k) {
      if (typeof payload[k] !== 'string') return;
      payload[k] = (STRUCTURED[k] ? payload[k] : scrub(maskUnverified(payload[k]))).slice(0, 100); /* GA4 参数值上限 100 字符 */
    });
    payload.page_location = safeUrl(window.location.href, true);
    if (document.referrer) payload.page_referrer = safeUrl(document.referrer, false);
    if (MODE === 'internal') { payload.traffic_type = 'internal'; payload.debug_mode = true; }
    try { log.push({ event: name, mode: MODE, params: payload }); if (log.length > 200) log.shift(); } catch (e) { /* 忽略 */ }
    if (MODE === 'off') return;
    var cfg = window.__ga4ThemeConfig;
    if (opts && opts.beforeLeave && cfg) {
      try {
        var id = Date.now() + '-' + Math.random().toString(36).slice(2, 8);
        var q = JSON.parse(window.sessionStorage.getItem(CARRY_KEY) || '[]');
        q.push({ id: id, n: name, p: payload, t: Date.now() });
        window.sessionStorage.setItem(CARRY_KEY, JSON.stringify(q.slice(-10)));
        /* 实际没有跳转（如 06 同页切换车型）：仍在本页、且 GA4 已加载完时取出直接发。先等 10 秒：首页 / 页头选车先请求目标页再跳转，
           请求慢时也要先跳走、交给下一页补发，不能在跳转前取出（取出后 GA4 还要约 5 秒才送出）；已被补发取走的不再重复发 */
        var settle = function () {
          try {
            var left = JSON.parse(window.sessionStorage.getItem(CARRY_KEY) || '[]');
            var mine = left.filter(function (e) { return e && e.id === id; })[0];
            if (!mine) return;
            window.sessionStorage.setItem(CARRY_KEY, JSON.stringify(left.filter(function (e) { return e && e.id !== id; })));
            deliver(mine.n, mine.p);
          } catch (e) { /* 忽略 */ }
        };
        window.setTimeout(function () { whenGaReady(settle); }, 10000);
        return;
      } catch (e) { /* 存不了就照常发 */ }
    }
    deliver(name, payload);
  }
  /* 上一页跳转前没送出的事件由 assets/auxito-cart-drawer.js（全站加载）在下一页补发，跳到非专题页也能补 */

  /* ---------- 本页编号与车型 ---------- */
  var outsideState = 'none'; /* 10 页网址带进来的非上线车型：none / pending / ok / rejected */
  var bsgConfirmed = null;   /* 06：已确认（页面加载时或点 Go 成功）的车型，不用下拉里还没确认的值 */
  function pageNo() {
    var root = document.querySelector('.apsp[data-apsp-screen]');
    return forcedPage || (document.querySelector('.apsp.bsg2') ? '06' : (root ? root.getAttribute('data-apsp-screen') : ''));
  }
  function context() {
    if (!pageCtx) {
      var page = pageNo();
      var root = document.querySelector('.apsp[data-apsp-screen]');
      var c = window.AuxitoProtoShellVehicle || null;
      var v = null;
      var supported = '';
      /* 页面固定车型（09 Challenger 版：data-apsp-fixed-vehicle）优先；10 页非上线车型（context.js outside，车型目录确认后才用）；其余为上线车型 */
      var fixed = root && root.getAttribute('data-apsp-fixed-vehicle');
      if (fixed) { var fp = fixed.split('|'); v = { year: fp[0], make: fp[1], model: fp[2] }; supported = 'no'; }
      /* outside.supported：上线车型、只是这一页没有内容（09 暂无 Builder），埋点仍记上线车型（2.0.12 审查） */
      else if (c && c.outside) { if (outsideState === 'ok' || c.outside.supported) { v = c.outside; supported = c.outside.supported ? 'yes' : 'no'; } }
      else if (c && c.current && (c.source !== 'default' || c.page)) { v = c.current; supported = 'yes'; }
      /* 02 是车型级页面：不报年份（context.js 会补一个默认年份，不是用户选的） */
      var f = vehicleFields(v, page === '02');
      if (!f.vehicle_key) supported = '';
      var ctx = {
        apsp_page: page,
        vehicle_key: f.vehicle_key,
        vehicle_year: f.vehicle_year,
        vehicle_make: f.vehicle_make,
        vehicle_model: f.vehicle_model,
        vehicle_supported: supported,
        position: c && c.position ? clean(c.position, 40) : ''
      };
      if (page === '06') { /* 06 的车型以页面已确认的车为准 */
        var b = vehicleFields(bsgConfirmed, false);
        ctx.vehicle_key = b.vehicle_key; ctx.vehicle_year = b.vehicle_year; ctx.vehicle_make = b.vehicle_make; ctx.vehicle_model = b.vehicle_model;
        ctx.vehicle_supported = b.vehicle_key && bsgConfirmed ? supportedOf(bsgConfirmed.year, bsgConfirmed.make, bsgConfirmed.model) : '';
      }
      /* 结果未定（10 页车型还在查目录）时不缓存，查完再算 */
      if (outsideState === 'pending') return ctx;
      pageCtx = ctx;
    }
    return pageCtx;
  }
  function bsgPicked() {
    var card = document.querySelector('.apsp.bsg2 [data-bsg2-picker]');
    if (!card) return null;
    var pick = function (sel) { var el = card.querySelector(sel); return el && el.value && !/^(year|make|model)$/i.test(el.value) ? el.value : ''; };
    var v = { year: pick('[data-bsg2-year]'), make: pick('[data-bsg2-make]'), model: pick('[data-bsg2-model]') };
    return v.year && v.make && v.model ? v : null;
  }
  /* 非上线车型（只来自网址或访客保存）：在全站车型目录（auxito-vehicle-utils.js）里查到 年份 + 品牌 + 车型 才算真车型 */
  function verifyInCatalog(v) {
    var u = window.AuxitoVehicleUtils;
    if (!v || !safeYear(v.year) || !u || typeof u.getYearVehicleData !== 'function' || typeof u.getAvailableModels !== 'function') return Promise.resolve(false);
    var timer = new Promise(function (resolve) { window.setTimeout(function () { resolve(false); }, 4000); });
    var check = Promise.resolve(u.getYearVehicleData(String(v.year))).then(function (data) {
      var want = String(v.model || '').trim().toLowerCase();
      return (u.getAvailableModels(data, v.make) || []).some(function (m) { return String(m).trim().toLowerCase() === want; });
    }).catch(function () { return false; });
    return Promise.race([check, timer]);
  }

  /* ---------- 模块：固定 ID（data-apsp-module）为准，标题只作展示 ---------- */
  function titleOf(box) {
    var h = box && box.querySelector('h1, h2, h3');
    return h ? clean(h.textContent, 60) : '';
  }
  function moduleInfo(el) {
    if (!el || !el.closest) return { id: '', title: '' };
    if (el.closest('.apsp-crumb, .apsp-crumb-bar, nav[aria-label="Breadcrumb"]')) return { id: 'breadcrumb', title: 'Breadcrumb' };
    if (el.closest('[data-vehicle-modal]')) return { id: 'add-vehicle-modal', title: 'Add Vehicle' };
    if (el.closest('.apsp-ymm-sheet')) return { id: 'hero', title: 'Hero' }; /* 01 手机端选车浮层是横幅的一部分 */
    if (el.closest('.apsp-vmodal')) return { id: 'video-modal', title: 'Video' };
    var box = el.closest('[data-apsp-module]');
    if (box) return { id: box.getAttribute('data-apsp-module'), title: titleOf(box) };
    var sec = el.closest('section, aside');
    var t = titleOf(sec);
    return { id: t ? 'untagged-' + slug([t]).slice(0, 40) : '', title: t };
  }
  function moduleViewed(info) {
    if (!info.id || sentModules[info.id]) return;
    sentModules[info.id] = true;
    send('apsp_module_view', { apsp_module: info.id, apsp_module_title: info.title });
  }

  /* 链接去哪类页面：车型页编号 / collection / product / video / legacy（旧版车型页）/ search_result（通用搜索结果页）/ external */
  function targetOf(href) {
    if (!href) return '';
    var u;
    try { u = new URL(href, window.location.href); } catch (e) { return ''; }
    if (u.origin !== window.location.origin && !/auxito\.com$/.test(u.hostname)) return /youtu/.test(u.hostname) ? 'video' : 'external';
    var p = u.pathname;
    var view = (/proto-shell-(\d\d)/.exec(u.searchParams.get('view') || '') || [])[1];
    if (view) return view;
    if (p === '/pages/vehicle-finder') return '01'; /* 01 / 09 / 10 正式固定页面（snippets/auxito-proto-shell-vehicles.liquid 的 pages） */
    if (p === '/pages/lighting-builder') return '09';
    if (p === '/pages/off-road-lighting-builder') return '10';
    if (p.indexOf('/pages/vehicle-year/') === 0) return u.searchParams.get('view') === 'builder' ? '09' : '03';
    if (p.indexOf('/pages/vehicle-lighting/') === 0) return '04';
    if (p.indexOf('/pages/vehicle-fitment/') === 0) return '05';
    if (p === '/pages/search-result') return u.searchParams.get('view') === 'search-result-plp-type' ? '05' : 'search_result';
    if (p.indexOf('/pages/install/') === 0) return '07';
    if (p.indexOf('/blogs/owner-stories/') === 0) return '08';
    if (p.indexOf('/pages/vehicle/') === 0) return '02';
    if (p === '/pages/vehicle') return 'legacy';
    if (/bulb-size/.test(p) || u.searchParams.get('view') === 'bulb-size-guide-v2') return '06';
    if (p.indexOf('/products/') >= 0) return 'product';
    if (p.indexOf('/collections/') === 0) return 'collection';
    if (p.indexOf('/cart') === 0 || p.indexOf('/checkouts') >= 0) return 'cart';
    return 'other';
  }

  /* 按钮文字：卡片取标题（不把说明和 CTA 拼进来），其他取 aria-label / 可见文字的第一行 */
  function labelOf(el) {
    var aria = el.getAttribute('aria-label');
    if (aria) return clean(aria, 100);
    var head = el.matches('.card, a.card, [data-task-link], [data-guide-link], [data-garage-card], [class*="card"]') && el.querySelector('h3, h4, b, strong');
    if (head) return clean(head.textContent, 100);
    /* 取原文（textContent），不用 innerText：CSS 大写的按钮会变成 ADD ALL TO CART；块级子元素多时才取显示文字的第一行 */
    var text = clean(el.textContent, 200);
    if (text.length > 60) text = String(el.innerText || '').split('\n').map(function (s) { return s.trim(); }).filter(Boolean)[0] || text;
    return clean(text || el.getAttribute('title'), 100);
  }

  function itemOf(el) {
    var holder = el.closest('[data-name], [data-or-name], .apsp-lb-row, [data-or-product]');
    if (!holder && el.closest('[data-bsg2-yblock]')) { /* 06 表格行：取该行的灯位名（表格第一格 / 手机列表第一项） */
      var tr = el.closest('tr');
      var li = el.closest('.bsg2-mlist > li');
      var cell = tr ? tr.cells[0] : (li ? li.querySelector('.bsg2-mrow__pos') : null); /* 手机行：只取灯位名 */
      return cell ? clean(cell.textContent, 60) : '';
    }
    if (!holder) return '';
    return clean(holder.getAttribute('data-or-name') || holder.getAttribute('data-name') || '', 80);
  }
  /* 06 年份段：只收「字母数字 + 年份范围」写法，不做电话清理 */
  function yearsOf(el) {
    var yb = el.closest('[data-bsg2-yblock]');
    var v = yb ? clean(yb.getAttribute('data-bsg2-yblock'), 60) : '';
    return /^[A-Za-z0-9 .&'\/()+-]*(?:19|20)\d\d(?:\s*[–-]\s*(?:19|20)\d\d)?$/.test(v) ? v : '';
  }

  var CLICKABLE = 'a[href], button, [role="button"], [role="link"], [data-task-link], [data-guide-link], [data-garage-card], summary';

  function onClick(event) {
    var el = event.target && event.target.closest && event.target.closest(CLICKABLE);
    if (!el || !isTracked(el)) return;
    var info = moduleInfo(el);
    moduleViewed(info); /* 点击的模块一定算曝光过，点击率不会超过 100% */
    var label = labelOf(el);
    var href = el.getAttribute('href') || el.getAttribute('data-task-link') || el.getAttribute('data-guide-link') || '';
    var video = el.closest('a.apsp-video-card[data-video-id], [data-video-id], [data-bsg2-video]');
    var title = video && video.querySelector('h3, h4, b, strong');
    if (video) label = clean(title ? title.textContent : label, 100);
    send('apsp_click', {
      apsp_module: info.id,
      apsp_module_title: info.title,
      apsp_label: label,
      apsp_item: itemOf(el),
      apsp_target: video ? 'video' : targetOf(href),
      content_years: yearsOf(el)
    });
    if (video) {
      send('apsp_video_open', {
        apsp_module: info.id, apsp_module_title: info.title, apsp_label: label,
        video_id: clean(video.getAttribute('data-video-id') || video.getAttribute('data-bsg2-video'), 20)
      });
    }
  }

  /* 键盘激活自定义卡片（div / role=button 等，Enter / 空格）：和点击一样记；原生按钮 / 链接按键会自己触发 click，不重复记 */
  function onKey(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var el = event.target && event.target.closest && event.target.closest(CLICKABLE);
    if (!el || el.matches('a[href], button, summary, input, select, textarea')) return;
    onClick({ target: el });
  }

  /* 上线车型清单（全站）：layout 从车型索引输出 年份|品牌|车型|车型库车名;…（小写），与车型页 context.js 的 match 同一规则（年份 + 品牌 + 车型或车型库车名） */
  var launchedList = null;
  function lcName(x) { return String(x || '').trim().toLowerCase().replace(/\s+/g, ' '); }
  function launchedMatch(year, make, model) {
    if (launchedList === null) {
      launchedList = [];
      var tag = document.querySelector('script[data-apsp-launched]');
      var raw = tag && tag.getAttribute('data-apsp-launched');
      if (raw) raw.split(';').forEach(function (row) { var p = row.split('|').map(lcName); if (p.length >= 3) launchedList.push(p); });
    }
    if (!launchedList.length) return null; /* 没有清单：未知 */
    var lc = lcName;
    var y = String(year), mk = lc(make), md = lc(model);
    return launchedList.some(function (p) { return p[0] === y && p[1] === mk && (p[2] === md || (p[3] && p[3] === md)); });
  }
  function supportedOf(year, make, model) {
    var c = window.AuxitoProtoShellVehicle;
    if (c && typeof c.match === 'function') return c.match(year, make, model) ? 'yes' : 'no';
    var hit = launchedMatch(year, make, model);
    return hit === null ? '' : (hit ? 'yes' : 'no');
  }

  /* 选车成功：由各处业务代码在接受选择、确定去向后调用（不在点击时猜，点了但没选成功的不算）。
     传进来的值都来自选车下拉（车型目录 / 车型清单），本事件的 vehicle_* 也换成所选车型，避免「旧页面车型 + 新车型支持状态」混在一起 */
  /* 全站选车器（车型页以外）：值可能来自访客保存的车型（如页头「编辑已保存车型」会带出网址同步进来的任意文字），
     上报前在全站车型目录（auxito-vehicle-utils.js）里确认 年份 + 品牌 + 车型，并换成目录里的标准写法；查不到不报（PR #55 埋点第七轮审查） */
  var SITE_SOURCES = { header_garage: 1, category_menu: 1, pdp_fitment: 1, home_finder: 1, bsg_search: 1, brand_finder: 1, kit_offer: 1 };
  function catalogCanonical(year, make, model) {
    var u = window.AuxitoVehicleUtils;
    var y = safeYear(year);
    if (!y || !u || typeof u.getYearVehicleData !== 'function' || typeof u.getAvailableModels !== 'function') return Promise.resolve(null);
    var lc = function (x) { return String(x || '').trim().toLowerCase(); };
    var timer = new Promise(function (resolve) { window.setTimeout(function () { resolve(null); }, 4000); });
    var check = Promise.resolve(u.getYearVehicleData(y)).then(function (data) {
      var makes = [];
      if (data && data.makes) makes = Object.keys(data.makes);
      else Object.keys(data || {}).forEach(function (cat) { Object.keys((data[cat]) || {}).forEach(function (m) { if (makes.indexOf(m) < 0) makes.push(m); }); });
      var mk = makes.filter(function (m) { return lc(m) === lc(make); })[0];
      if (!mk) return null;
      var md = (u.getAvailableModels(data, mk) || []).filter(function (m) { return lc(m) === lc(model); })[0];
      return md ? { year: y, make: mk, model: md } : null;
    }).catch(function () { return null; });
    return Promise.race([check, timer]);
  }
  function vehicleSelected(source, year, make, model, supported) {
    if (SITE_SOURCES[source]) {
      catalogCanonical(year, make, model).then(function (v) { if (v) emitVehicleSelected(source, v.year, v.make, v.model, supported); });
      return;
    }
    emitVehicleSelected(source, year, make, model, supported);
  }
  function emitVehicleSelected(source, year, make, model, supported) {
    var f = vehicleFields({ year: year, make: make, model: model }, false);
    if (!f.vehicle_key) return;
    if (supported == null || supported === '') supported = supportedOf(year, make, model);
    supported = supported === true ? 'yes' : (supported === false ? 'no' : supported);
    if (source === 'bsg_card') { bsgConfirmed = { year: year, make: make, model: model }; pageCtx = null; }
    send('apsp_vehicle_select', {
      apsp_source: clean(source, 30),
      selected_year: f.vehicle_year,
      selected_make: f.vehicle_make,
      selected_model: f.vehicle_model,
      vehicle_key: f.vehicle_key,
      vehicle_year: f.vehicle_year,
      vehicle_make: f.vehicle_make,
      vehicle_model: f.vehicle_model,
      vehicle_supported: supported
    }, { beforeLeave: true });
  }
  function result(name, extra) {
    var p = { apsp_result: clean(name, 40) };
    Object.keys(extra || {}).forEach(function (k) { p[k] = extra[k]; });
    send('apsp_result', p);
  }
  var playedVideos = {};
  function videoPlaying(id, title, el) {
    if (!id || playedVideos[id]) return;
    playedVideos[id] = true;
    var info = moduleInfo(el || null);
    send('apsp_video_play', { apsp_module: info.id, apsp_module_title: info.title, apsp_label: clean(title, 100), video_id: clean(id, 20) });
  }

  function onChange(event) {
    var el = event.target;
    if (!el || el.tagName !== 'SELECT' || !isTracked(el)) return;
    if (el.closest('.hero-form, [data-apsp-vcard], [data-vehicle-modal], .bsg2-year-card, .apsp-ymm-sheet')) return; /* 选车下拉看 apsp_vehicle_select */
    var info = moduleInfo(el);
    send('apsp_select', {
      apsp_module: info.id,
      apsp_module_title: info.title,
      apsp_field: clean(el.getAttribute('aria-label') || el.getAttribute('name') || (el.closest('[data-name]') ? el.closest('[data-name]').getAttribute('data-name') : ''), 60),
      apsp_value: clean(el.options[el.selectedIndex] ? el.options[el.selectedIndex].textContent : el.value, 80),
      apsp_item: itemOf(el)
    });
  }

  /* 只记车型专题页内容区（.apsp / 05 的商品结果区 / 页面里挂到 body 的选车浮层与视频弹窗），不记页头页脚与侧边购物车 */
  function isTracked(el) {
    if (el.closest('.auxito-cart-drawer, header, footer, .site-header, .site-footer, #shopify-section-static-header')) return false;
    if (forcedPage === '05') return !!el.closest('main'); /* 05 的商品结果在通用搜索结果模板里，不在 .apsp 作用域内 */
    return !!el.closest('.apsp, .apsp-plp-type-scope, .apsp-ymm-sheet, .apsp-vmodal, [data-apsp-track-area]');
  }

  /* ---------- 订单归因（购物车私有属性，写入逻辑在 assets/auxito-cart-drawer.js 的 AuxitoCartAttribution） ----------
     __apsp_vehicle_pages：这个购物车第一次来自哪个车型页（「页面编号 车型」）；__apsp_builder：这个购物车用过哪个 Builder 加购。
     本页只把待写内容存进当前标签页（Builder 按加购后的购物车记），由购物车刷新时写入；访客拒绝分析统计时清掉待写、不写。 */
  var PENDING_KEY = 'apsp:pending-cart-attrs';
  function consentState() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.analyticsProcessingAllowed !== 'function') return 'unknown';
      return cp.analyticsProcessingAllowed() ? 'allowed' : 'denied';
    } catch (e) { return 'unknown'; }
  }
  function readPending() {
    try { return JSON.parse(window.sessionStorage.getItem(PENDING_KEY) || 'null') || {}; } catch (e) { return {}; }
  }
  function writePending(p) {
    try { window.sessionStorage.setItem(PENDING_KEY, JSON.stringify(p)); } catch (e) { /* 忽略 */ }
  }
  function clearPending() {
    try { window.sessionStorage.removeItem(PENDING_KEY); } catch (e) { /* 忽略 */ }
  }
  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; });
  }
  /* 有购物车才去读（不为埋点新建购物车），交给侧边购物车脚本写入 */
  function flushNow() {
    var A = window.AuxitoCartAttribution;
    if (!A || typeof A.flush !== 'function' || !/(?:^|;\s*)cart=/.test(document.cookie)) return;
    try { getCart().then(function (cart) { if (cart) A.flush(cart); }).catch(function () { /* 下次购物车刷新再写 */ }); } catch (e) { /* 忽略 */ }
  }
  function recordFirstTouch(tries) {
    var state = consentState();
    if (state === 'unknown') { if ((tries || 0) < 6) window.setTimeout(function () { recordFirstTouch((tries || 0) + 1); }, 1500); return; }
    if (state !== 'allowed') { clearPending(); return; }
    var p = readPending();
    if (p.__apsp_vehicle_pages && TEST_PREFIX && String(p.__apsp_vehicle_pages).indexOf(TEST_PREFIX) !== 0) {
      p.__apsp_vehicle_pages = TEST_PREFIX + p.__apsp_vehicle_pages; /* 测试中：已有来源也标成测试，Buy Now 等路径一起带上 */
      writePending(p);
    }
    if (!p.__apsp_vehicle_pages) {
      var c = context();
      /* 车型没确认（如 10 页网址车型在目录里查不到）就只记页面编号 */
      var label = clean([c.apsp_page, c.vehicle_year, c.vehicle_make, c.vehicle_model].filter(Boolean).join(' '), 110);
      if (!label) return;
      p.__apsp_vehicle_pages = TEST_PREFIX + label;
      writePending(p);
    }
    var run = function () { flushNow(); };
    if ('requestIdleCallback' in window) window.requestIdleCallback(run, { timeout: 4000 }); else window.setTimeout(run, 1500);
  }
  /* Builder 加购成功后调用（同步）：先记成未绑定，下一次读到购物车（加购后的侧边购物车刷新）时由 cart-drawer 绑定到该购物车并和来源一起写入 */
  function markBuilder(page) {
    if (consentState() === 'denied') { clearPending(); return; }
    var p = readPending();
    var list = Array.isArray(p.unbound) ? p.unbound : [];
    /* 记下加购时的购物车（cookie），只绑定到同一个购物车，读不到 cookie 就不记 */
    var cm = /(?:^|;\s*)cart=([^;]+)/.exec(document.cookie || '');
    var cartToken = '';
    try { cartToken = cm ? decodeURIComponent(cm[1]).split('?')[0] : ''; } catch (e) { cartToken = ''; }
    if (!cartToken) return;
    list.push({ n: TEST_PREFIX + (page === '10' ? '10 Off-Road Builder' : '09 LED Builder'), at: Date.now(), token: cartToken });
    p.unbound = list.slice(-5);
    writePending(p);
    flushNow(); /* 侧边购物车不可用时也能写 */
  }

  /* ---------- 模块曝光 ---------- */
  function watchModules() {
    if (!('IntersectionObserver' in window)) return;
    var near = [];
    var hiddenNow = function (el) {
      if (el.closest('[hidden], [aria-hidden="true"]')) return true;
      var cs = window.getComputedStyle(el);
      return cs.visibility === 'hidden' || cs.display === 'none' || Number(cs.opacity) === 0;
    };
    var seenEnough = function (el) {
      if (hiddenNow(el)) return false; /* 占位中（如 05 还没显示的配置选择区）不算曝光 */
      var r = el.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var visible = Math.max(0, Math.min(r.bottom, vh) - Math.max(r.top, 0));
      return r.height > 0 && (visible / r.height >= 0.4 || visible >= vh * 0.4);
    };
    var mark = function (el) {
      near = near.filter(function (x) { return x !== el; });
      io.unobserve(el);
      moduleViewed({ id: el.getAttribute('data-apsp-module'), title: titleOf(el) });
    };
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var el = entry.target;
        if (!entry.isIntersecting) { near = near.filter(function (x) { return x !== el; }); return; }
        if (seenEnough(el)) mark(el); else if (near.indexOf(el) < 0) near.push(el);
      });
    }, { threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.6] });
    /* 比视口高很多的模块（如 06 长表格）可见比例很小、阈值不会再触发：在视口里的这类模块滚动时再量一次可见高度 */
    var ticking = false;
    var recheck = function () {
      ticking = false;
      near.slice().forEach(function (el) { if (seenEnough(el)) mark(el); });
    };
    var onScroll = function () { if (near.length && !ticking) { ticking = true; window.requestAnimationFrame(recheck); } };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    /* 在视口里但还隐藏的模块，显示出来时（class / hidden / aria-hidden / style 变化）再量一次 */
    var mo = 'MutationObserver' in window ? new MutationObserver(onScroll) : null;
    Array.prototype.forEach.call(document.querySelectorAll('[data-apsp-module]'), function (box) {
      if (!isTracked(box) && !(forcedPage === '05' && box.closest('main'))) return;
      io.observe(box);
      if (mo) mo.observe(box, { attributes: true, attributeFilter: ['class', 'hidden', 'aria-hidden', 'style'] });
    });
  }

  /* ---------- 05：商品结果状态（不改线上共用的 search-result 脚本，只看结果区的变化） ---------- */
  function watchResults() {
    var grid = document.getElementById('js-productgrid--items');
    if (!grid || !('MutationObserver' in window)) return;
    var last = '';
    var timer = 0;
    var check = function () {
      if (grid.classList.contains('is-loading')) return;
      var state;
      var seen = {};
      Array.prototype.forEach.call(grid.querySelectorAll('a[href*="/products/"]'), function (a) {
        var m = /\/products\/([^/?#]+)/.exec(a.getAttribute('href') || '');
        if (m) seen[m[1]] = 1;
      });
      var count = Object.keys(seen).length;
      /* 先看有没有商品：有商品时的提示（如「部分数据刷新失败、显示缓存」）不算空结果 */
      if (grid.querySelector('.search-result-locked-board')) state = 'config_required';
      else if (count) state = 'products';
      else if (grid.querySelector('.search-result-status--error')) state = 'load_failed';
      else if (grid.querySelector('.search-result-status')) state = 'no_products';
      else return;
      var sig = state + ':' + count + ':' + window.location.search;
      if (sig === last) return;
      last = sig;
      result(state, count ? { result_count: count } : null);
    };
    new MutationObserver(function () { window.clearTimeout(timer); timer = window.setTimeout(check, 800); })
      .observe(grid, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    timer = window.setTimeout(check, 800);
  }

  function begin() {
    send('apsp_page_view', { page_path: window.location.pathname, apsp_version: VERSION });
    recordFirstTouch();
    document.addEventListener('click', onClick, true);
    document.addEventListener('change', onChange, true);
    document.addEventListener('keydown', onKey, true);
    watchModules();
    if (forcedPage === '05') watchResults();
  }
  function start() {
    if (!document.querySelector('.apsp, .apsp-plp-type-scope')) return;
    /* 访客之后才做同意选择：允许就记来源，拒绝就清掉待写（Shopify visitorConsentCollected） */
    document.addEventListener('visitorConsentCollected', function () { recordFirstTouch(); });
    if (pageNo() === '06') bsgConfirmed = bsgPicked();
    var c = window.AuxitoProtoShellVehicle;
    if (c && c.outside && !document.querySelector('.apsp[data-apsp-fixed-vehicle]')) {
      /* 10 页网址带进来的非上线车型：目录里查到才当车型上报，查不到就当没有车型 */
      outsideState = 'pending';
      verifyInCatalog(c.outside).then(function (ok) {
        outsideState = ok ? 'ok' : 'rejected';
        pageCtx = null;
        begin();
      });
      return;
    }
    begin();
  }

  window.AuxitoTrack = {
    send: send,
    moduleView: function (id, title) { moduleViewed({ id: id, title: title || '' }); },
    context: context,
    vehicleSelected: vehicleSelected,
    result: result,
    videoPlaying: videoPlaying,
    markBuilder: markBuilder,
    mode: MODE
  };
  /* context.js（车型）与本脚本都是 defer；等 DOMContentLoaded 后再读车型和模块 */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
